<template>
  <div class="modal nb-modal-mask" style="display:block; z-index: 1 !important;">
    <div
      class="modal-dialog modal-dialog-centered modal-lg"
      role="document"
      style="max-width: 90%; width: 90% !important;overflow-y: initial !important;">
      <div class="modal-content">
        <div
          class="modal-body pt-3"
          style="height: 80vh!important; max-height: 100%; overflow-y: auto;"
          @scroll="handleScroll">
          <div class="lbl mb-2" style="font-size: 20px">
            <strong>Consulta Vendas Abertas</strong>
          </div>
          <button @click="closeModal" class="close">
            <span>&times;</span>
          </button>
          <div v-if="show">
            <alert v-if="varejoList.length === 0" text="Nenhuma venda encontrada" type="warning"></alert>
            <div v-for="(item,index) in filteredVarejoList" :key="index" class="mainbox">
              <div class="box mx-2 d-flex flex-wrap">
                <div class="col-md-1 col-2">
                  <v-label v-if="index==0" class="w-100" label="Pedido"></v-label>
                  <span class="data-list">{{ item.npedido }}</span>
                </div>
                <div class="col-md-2 col-2">
                  <v-label v-if="index==0" class="w-100" label="Data"></v-label>
                  <span class="data-list">{{
                    item.data | formatDataHora
                  }}</span>
                </div>
                <div class="col-md-2 col-2">
                  <v-label v-if="index==0" class="w-100" label="Cliente"></v-label>
                  <span class="data-list">{{ item.fantasia }}</span>
                </div>
                <div class="col-md-2 col-2">
                  <v-label v-if="index==0" class="w-100" label="Operador"></v-label>
                  <span class="data-list">{{ item.nome_usuario }}</span>
                </div>
                <div class="col-md-2 col-2">
                  <v-label v-if="index==0" class="w-100" label="Total do Pedido"></v-label>
                  <span class="data-list">R$
                    <strong>{{ item.totger | formatValue(2) }}</strong>
                  </span>
                </div>
                <div class="col-md-1 text-right ml-auto">
                  <span class="badge" :class="statusColor(item.stpedv, item.tppedv)">{{ textST(item) }}</span>
                  <span v-if="item.espera === 'S'" class="badge badge-warning">Em espera</span>
                </div>
                <div class="col-md-1 col-2 align-items-right ml-auto">
                  <bar-grid
                    :options="handleBarGrid(item.stpedv)"
                    @action="handleAction"
                    @view="handleEdit(item.codpedv)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
      codpart: null,
      query: {
        text: null,
        after: null,
        before: null,
        codstatus: null
      },
      offset: false,
      isLoading: false,
      show: false,
    };
  },
  computed: {
    varejoList() {
      return this.$store.getters.getPedvList;
    },
    filteredVarejoList() {
      return this.varejoList.filter(item => item.stpedv === 'D');
    },
    nextPage() {
      return this.$store.getters.getNextPage;
    },
  },
  methods: {
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      if (
        scrollHeight - (scrollTop + clientHeight) < 50 &&
        !this.isLoading &&
        this.nextPage > 0
      ) {
        this.loadMoreData();
      }
    },
    async loadMoreData() {
      if (this.isLoading || this.nextPage === 0) return;
      this.isLoading = true;
      this.offset = true;
      await this.loadData();
      this.isLoading = false;
    },

    async loadData() {
      const param = { query: 'filtroorigem=4' + (this.offset ? `&poffset=${this.nextPage}` : "") }
      await this.$store.dispatch("loadPedvList", param);
      console.log(this.varejoList)
      this.offset = false;
      this.show = true
    },
    closeModal() {
      this.$emit("close");
    },
    handleEdit(index) {
      this.$emit('selectedItem', index)
    },
    handleAction(index) {
    },
    statusColor(stpedv, tppedv) {
      if (stpedv === "C" || stpedv === "R" || tppedv === "R")
        return "badge-red";
      if (stpedv === "F") return "badge-blue";
      if (tppedv === "O") return "badge-orange";
      if (stpedv === "D") return "badge-warning";
      if (tppedv === "P") return "badge-green";
      return "badge-green";
    },
    textST(item) {
      let text = item.tppedv === "O" ? "Orçamento" : "Venda";
      if (item.tppedv === "R") return "Orçamento Perdido";
      if (item.stpedv === "C") text += " Cancelada";
      else if (item.stpedv === "R") text += " Rejeitado";
      else if (item.stpedv === "A") text += " Em Aprovação";
      else if (item.stpedv === "F") text = "Nota Emitida";
      else if (item.stpedv === "D") text += " Aberta";
      return text;
    },
    handleBarGrid(stpedv) {
      return { barDefault: true, btnView: true };
    },
  },
  created() {
    this.loadData();
  },
  beforeDestroy() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip('dispose').removeAttr('data-toggle')
    })
  }
};
</script>

<style scoped>
.mainbox {
  overflow: visible;
}
.main-content {
  overflow-y: hidden;
}
.box {
  float: none;
}
</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-modal-vendas.vue